import useSWR from "swr"
import { PullSheetApi } from "../../../apis"
import type { IPullSheetLine } from "../../../models/PullSheetLine"

/** Lines of one pull sheet (name, SKU, loaded quantity) so shortages show names, never line ids. */
export function usePullSheetLinesQuery(pullSheetId: string | null | undefined) {
  return useSWR(
    pullSheetId ? ["pull-sheet-lines", pullSheetId] : null,
    async () => {
      const ps = await PullSheetApi.get(pullSheetId as string)
      return (ps?.pullSheetLines ?? []) as IPullSheetLine[]
    },
    { revalidateOnFocus: false },
  )
}
